import { Accordion } from 'react-bootstrap';

interface PageHeaderProps {
  title: string;
}

export const PageHeader = ({ title }: PageHeaderProps) => (
  <div className="mb-3">
    <div className="d-flex justify-content-between align-items-start mb-2">
      <div>
        <h2 className="mb-0" style={{ color: '#000000', fontSize: '28px', fontWeight: 600 }}>
          {title}
        </h2>
      </div>
      <div style={{ minWidth: '300px' }}>
        <Accordion>
          <Accordion.Item eventKey="0" className="border-0" style={{ backgroundColor: 'transparent' }}>
            <Accordion.Header className="p-0">
              <span style={{ color: '#3d1690', fontWeight: 500, fontSize: '14px' }}>Quick Guide</span>
            </Accordion.Header>
            <Accordion.Body className="p-2">
              <div className="d-flex flex-column gap-2">
                <div className="d-flex align-items-center gap-2">
                  <kbd
                    style={{
                      backgroundColor: '#3d1690',
                      color: 'white',
                      minWidth: '24px',
                      height: '24px',
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      borderRadius: '4px',
                    }}
                  >
                    1-3
                  </kbd>
                  <span className="small">Select competitor product</span>
                </div>
                <div className="d-flex align-items-center gap-2">
                  <kbd
                    style={{
                      backgroundColor: '#3d1690',
                      color: 'white',
                      minWidth: '24px',
                      height: '24px',
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      borderRadius: '4px',
                    }}
                  >
                    q
                  </kbd>
                  <span className="small">Skip current competitor</span>
                </div>
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </div>
    </div>
  </div>
);
